import { useEffect } from 'react';
import gsap from 'gsap';
import '../Project.css';

import banner from '../../assets/images/RAD_Banner.png';
import lb from '../../assets/images/RAD_Leaderboard.png';
import ghost from '../../assets/images/RAD_ghost.png';
import cutscene from '../../assets/images/RAD_cutscene.png';
import plexis from '../../assets/images/RAD_plexis.png';
import locators from '../../assets/images/RAD_locators.png';

function RAD() {

    useEffect(() => {
        var tl = gsap.timeline();
        tl.fromTo('.projectContainer', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1 });
    }, []);

    return (
        <div className='projectContainer'>
            <img src={banner} alt='Rad Ascension' className='projectBanner' />
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', marginBottom: '20px' }}>
                    <div>
                        <h1>Info</h1>
                        <ul>
                            <li><b>Engine:</b> Unity</li>
                            <li><b>Platforms:</b> <a href="https://store.steampowered.com/app/854850/RAD_Ascension/" target="_blank" rel="noreferrer">Steam</a></li>
                            <li><b>Role:</b> Systems & Gameplay Programmer</li>
                            <li><b>Time:</b> 1 year</li>
                        </ul>
                    </div>
                    <div>
                        <h1>Responsabilities</h1>
                        <ul>
                            <li>Expanding player movement</li>
                            <li>Implementing Steam exlusive features</li>
                            <li>Created recording and replay system</li>
                            <li>Developed tools and VFXs for artists</li>
                        </ul>
                    </div>
                </div>
                <iframe width="80%" height="500px" src="https://www.youtube.com/embed/OOs-P9sgSrA" title="RAD: Ascension Trailer" allowFullScreen/>
                <hr className='divider' />
                <div>
                    <h1>Player Movement</h1>
                    <br/>
                    <p>
                        One of my first tasks was to create a flight/glide state for the player movement state machine. Using a slightly modified version of the drag 
                        and lift physics formulas, I created something that is realistic enought to be intuitive while also feeling good and responsive to use.
                    </p>
                </div>
                <hr className='divider' />
                <div style={{ width: '100%' }}>
                    <h1>Steam Integration</h1>
                    <br/>
                    <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div>
                                <p>
                                    My biggest contribution to this project was implemanting the Steamworks.NET SKD to take full advantage of the services Steam provides.
                                    Primarily, I made it so every level in the game has a coresponding leaderboard that saves each player's best time and a recording of that 
                                    run that other players can download and race against (more of that in a bit).
                                </p>
                                <br/>
                                <p>
                                    Additionaly, I added a simple way to use Steam Statistics to measure player engagement and difficulty of each level by tracking statistics 
                                    like time spent, how many attempts are successful and how many times players manually reset. The aggregated numbers can then be fetched 
                                    through Steamworks WEB API by a simple Python script.
                                </p>
                            </div>
                        </div>
                        <img src={lb} alt='leaderboard' style={{ maxWidth: '400px' }} />
                    </div>
                </div>
                <hr className='divider' />
                <div style={{ width: '100%' }}>
                    <h1>Replay</h1>
                    <br/>
                    <p>
                        In order to encourage players to strive for better times, I created a tool that records the player's state and transform into keyframes during a run that 
                        gets saved whenever they beat their own score. Then that information is used to animate a "ghost" that players can run against.
                    </p>
                    <br/>
                    <p>
                        Once this was done, I also made it so the recording data file is uploaded to Steam and attached to that player's entry on the leaderboard of that level. 
                        Letting other players race against other's records by donwloading their ghost from the leaderboard.
                    </p>
                    <br/>
                    <p>
                        Later, the same system used to render the ghost would also be used to turn the dev's records into cutscenes that play on the main menu.
                    </p>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-evenly', marginTop: '10px' }}>
                        <img src={ghost} alt='ghost' style={{ width: '40%' }} />
                        <img src={cutscene} alt='cutscene' style={{ width: '40%' }} />
                    </div>
                </div>
                <hr className='divider' />
                <div style={{ width: '100%' }}>
                    <h1>Art</h1>
                    <br/>
                    <p>
                        RAD's art style is full of straight lines and sharp angles, so it makes sense for a decent amount of VFX to be made in code. I worked with artists to 
                        create effects and tools to enhance the asthetics of the game. Some of them include:
                    </p>
                    <ul>
                        <li>
                            <b>Plexis:</b> Spider web shaped lines on the outer edge of each level. Made by random semi-randomly 
                            scattering points and using them as vertices to render a wireframe mesh that reacts to sound
                        </li>
                        <li><b>Locators:</b> L-shaped lines that can connect to other locators to create dotted lines with line renderers to help players making long jumps</li>
                        <li><b>Checkpoints:</b> Marked by a shape made of 3 triangles that morphs into 3 hexagons when player gets close to it</li>
                    </ul>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-evenly', marginTop: '10px' }}>
                        <img src={plexis} alt='plexis' style={{ width: '40%' }} />
                        <img src={locators} alt='locators' style={{ width: '40%' }} />
                    </div>
                </div>
                {/*<hr className='divider' />
                <div style={{ width: '100%' }}>
                    <h1>Settings</h1>
                    <br/>
                    <p>
                        - audio
                        - input
                    </p>
                </div>*/}
            </div>
        </div>
    );
}

export default RAD;